import { render, staticRenderFns } from "./DynamicNavigation.vue?vue&type=template&id=617b0037&scoped=true&"
import script from "./DynamicNavigation.vue?vue&type=script&lang=ts&"
export * from "./DynamicNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicNavigation.vue?vue&type=style&index=0&id=617b0037&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b0037",
  null
  
)

export default component.exports